<template>
  <v-btn v-if="published != true" :state="false" color="error" outlined @click="togglePublish">
    <v-icon small class="mr-1">fa-times</v-icon>unpublished
  </v-btn>
  <v-btn v-else :state="true" color="primary" outlined @click="togglePublish">
    <v-icon small class="mr-1">fa-check</v-icon>published
  </v-btn>
</template>
<script>
import courseAPI from "@/api/course.js";
export default {
  name: "PublishToggle",
  props: {
    published: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: null
    }
  },
  methods: {
    togglePublish() {
      if (this.published) {
        courseAPI.publishCourse(this.id).then(response => {
          this.$store.dispatch("setCourse", response.data.data);
        });
      } else {
        courseAPI.unPublishCourse(this.id).then(response => {
          this.$store.dispatch("setCourse", response.data.data);
        });
      }
    }
  }
};
</script>